export default __webpack_public_path__ + "static/media/brainhi_logo_primary.5613ed1b.svg";